// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import IdApp from '@/components/secure/IdApp'
import router from './router'
import store from '@/vuex/store'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import ErrorLoggingService from '@/services/ErrorLoggingService'
import ConfigService from '@/services/ConfigService'
import { createBeforeEach } from '@/router/guards'
import { checkAuth } from '@/utils/auth-utils'

(async () => {
  Sentry.init({
    dsn: 'https://ad297824a6a64ad985ad1fa56d8b0006@sentry.io/181607',
    environment: ConfigService.environment(),
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })

  Vue.config.productionTip = false
  Vue.config.errorHandler = function (err) {
    ErrorLoggingService.logError(err)
  }

  try {
    await checkAuth(store, ConfigService.authorizeUrl())
  } catch (err) {
    return
  }

  router.beforeEach(createBeforeEach({ checkAuth, store }))
  new Vue({
    router,
    render (h) {
      return h(IdApp)
    },
    store
  }).$mount('#app')
})()
